import KunLoading87 from './src/index'

KunLoading87.install = function (Vue) {
	Vue.component(KunLoading87.name, KunLoading87);
}

export default KunLoading87;
